import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

// mui
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// utils
import downloadIcon from "../../../../../../../../../images/aji_image/downloadIcon.svg";
import DownloadTool from "../downloadTool/DownloadTool";
import ajiConfig from "../../ajiConfig";

const TopPanel = ({ chatMessage, isChatting, monthSub, QACount }) => (
  <Grid container justifyContent="space-between" alignItems="center" mb={2}>
    <Grid item>
      <Typography
        textAlign="left"
        variant="subtitle1"
        sx={{ fontWeight: 700, fontSize: "20px" }}
      >
        <FormattedMessage
          id="sna.sidetool.digitalAITool.aji.title"
          defaultMessage="阿記"
        />
      </Typography>
      <div
        style={{
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "20.27px",
          color: "#6D6D6D",
        }}
      >
        <span>
          {monthSub ? ajiConfig.monthSubQuotaTitle : ajiConfig.freeQuotaTitle}
        </span>
        <span style={{ fontWeight: "700", color: "#0EA2E9" }}>
          {monthSub
            ? ajiConfig.monthSubQuota
            : `${Math.max(
                0,
                Math.round(100 * (1 - QACount / ajiConfig.quota))
              )}%`}
        </span>
        <span>{!monthSub && ajiConfig.freeQuotaUpdateTitle}</span>
      </div>
      <Typography
        textAlign="left"
        variant="body2"
        sx={{ color: "#6D6D6D", fontSize: "14px" }}
      />
    </Grid>
    <Grid item>
      <DownloadTool
        chatMessage={chatMessage}
        isChatting={isChatting}
        downloadIcon={downloadIcon}
      />
    </Grid>
  </Grid>
);

TopPanel.propTypes = {
  chatMessage: PropTypes.array.isRequired,
  isChatting: PropTypes.bool.isRequired,
  monthSub: PropTypes.bool.isRequired,
  QACount: PropTypes.number.isRequired,
};

export default TopPanel;
